// extracted by mini-css-extract-plugin
module.exports = {"colorPickerContainer":"WorkingAreaDialog_colorPickerContainer__2Kao8","colorBox":"WorkingAreaDialog_colorBox__eBw1D"};